import { GlobalFeatureFlagTable } from '@frontend/wam-views';
import { Button } from '@frontend/design-system';
import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function GlobalSettings() {
  return (
    <Page
      title='Global Feature Flags'
      breadcrumbs={[
        {
          label: 'Global Settings',
        },
        {
          label: 'Feature Flags',
        },
      ]}
      action={<Button iconName='plus'>Add New Feature Flag</Button>}
    >
      <Container>
        <GlobalFeatureFlagTable />
      </Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/global-settings/feature-flags',
  component: GlobalSettings,
  type: 'auth',
});
